import React from 'react';
import { Block, DefaultText } from '@guryou/html-components';

const buttonStyle = {
  padding: '8px 12px',
  borderRadius: '999px',
  border: '2px solid #444',
  backgroundColor: '#1f1f1f',
  color: '#ccc',
  cursor: 'pointer',
  transition: 'all 0.2s ease-in-out',
  fontWeight: 'bold',
  fontFamily: 'monospace',
};

const WeeksCounter = ({ title = 'Weeks', value, onChange }) => {
  return (
    <Block marginBottom="0.6rem" width="auto">
      <DefaultText marginBottom="0.1rem" fontSize="1.1rem" fontWeight="800" color="#ccc">
        {title}
      </DefaultText>
      <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
        <button type="button" onClick={() => onChange(Math.max(1, value - 1))} style={buttonStyle}>
          -
        </button>
        <DefaultText textAlign="center" color="#e6616a" fontSize="1.2rem" fontFamily="monospace">
          {value}
        </DefaultText>
        <button type="button" onClick={() => onChange(value + 1)} style={buttonStyle}>
          +
        </button>
      </div>
    </Block>
  );
};

export default WeeksCounter;
